import {
  GetAccessTokenFunc,
  GetUserOrganizationsFunc
} from '@digital-services/shell';

import { fetcher } from '@/utils/swr-utils';

import { USER_ORGANIZATIONS_PATH } from './paths';

export default function useFetchUserOrganizations(): GetUserOrganizationsFunc {
  const fetchUserOrganizations = async (getAccessToken: GetAccessTokenFunc) => {
    if (!getAccessToken) {
      throw new Error(
        'Authentication is not initialized or access token is unavailable'
      );
    }
    const response = await fetcher(USER_ORGANIZATIONS_PATH, getAccessToken);

    return response.organizations;
  };

  return fetchUserOrganizations;
}
